/**
 * Canonical path for the incident details page (opens in a new tab from asset UI).
 */
export function buildIncidentDetailPath(incidentId: string): string {
  return `/incidents/${incidentId}`;
}
